<template lang="pug">
Auth(:on-failed-authentication="onFailedAuthentication")
  Header(@tweetPost="tweetPost")
  NowLoading(:show="showNowLoading")
  div.wrap-post
    ModulePost(v-if="uid" ref="modulePost", @setImgURL="setImgURL")
</template>

<style lang="scss" scoped>
.wrap-post {
  width: 100%;
  min-height: 100vh;
  padding-top: 48px;
}
</style>

<script>
import db, { api, firebase } from '@/components/utils/firebase'

import { createNamespacedHelpers } from 'vuex'
import Auth from '@/components/auth'
import Header from '@/components/common/Header'
import NowLoading from '@/components/common/NowLoading'
import ModulePost from '@/components/module/ModulePost'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
const { mapActions: mapActionsPost } = createNamespacedHelpers('post')

export default {
  components: {
    Auth,
    Header,
    NowLoading,
    ModulePost
  },
  computed: {
    ...mapStateAuth([
      'uid',
      'isAnonymous'
    ])
  },
  data () {
    return {
      showNowLoading: false,
      imgURL: null
    }
  },
  methods: {
    ...mapActionsPost([
      'setTweetToRetweet'
    ]),
    onFailedAuthentication () {
      this.$router.push('/sign-in')
    },
    async tweetPost () {
      var text = this.$refs.modulePost.postValue

      if (text === '') {
        alert('テキストを入力してね！')
        return false
      }

      this.showNowLoading = true

      var todayStart = new Date(new Date().setHours(0, 0, 0, 0))
      var todayPostsNum = await db.collection('posts')
        .where('author', '==', this.uid)
        .where('createdAt', '>=', todayStart)
        .get()
        .then(q => {
          return q.docs.length
        })

      if (todayPostsNum > 10) {
        alert('ごめんね。一日10回までしか投稿できないんだ。。明日また投稿してくれたら嬉しいな！')
        this.showNowLoading = false
        return false
      }

      const regex = /https*(:\/\/[-_.!~*¥'()a-zA-Z0-9;\/?:¥@&=+¥$,%#]+)/

      var isOverLimit = false
      if (text.match(regex)) {
        var textWithoutURL = text.replace(regex, '')
        if (textWithoutURL.length + 12 > 140) isOverLimit = true
      } else {
        if (text.length > 140) isOverLimit = true
      }
      if (isOverLimit) {
        alert('文字数がオーバーしてるよ〜')
        this.showNowLoading = false
        return false
      }

      if (text.indexOf('#アドミンナ') > -1) {
        alert('ハッシュタグ「#アドミンナ」はアドミン権限をもっているミンナだけが使えるの。。。ごめんね。')
        this.showNowLoading = false
        return false
      }

      var idToken = await firebase.auth().currentUser
        .getIdToken(true)
        .then(token => { return token })

      var params = {
        message: text,
        idToken
      }

      var selectedImg = this.$refs.modulePost.$refs.selectedImg
      if (selectedImg) {
        // var base64 = this.imageToBase64(selectedImg, 'image/png')
        var base64 = this.$refs.modulePost.$refs.selectedImg.src
        base64 = base64.split(",")[1]
        params.base64 = base64
        var selectedImgURL = this.$refs.modulePost.selectedImgURL
      }

      const response = await fetch(`${api}/tweetMessage`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(params)
      }).catch(() => { return false })

      if (!response) {
        alert('ツイートに失敗しました。一日のツイート上限が超えているかも。。。')
        this.showNowLoading = false
        return false
      }

      var result = await response.json()
      var tweetResponse = result.tweetResponse
      
      if (!tweetResponse) {
        alert('ツイートに失敗しました。一日のツイート上限が超えているかも。。。')
        this.showNowLoading = false
        return false
      }

      var postToDB = {
        author: this.uid,
        message: text, // tweetResponse.text,
        createdAt: new Date(),
        avatar: this.$route.params.id,
        alikes: [],
        unlikes: []
      }
      
      if (selectedImgURL) postToDB.img = selectedImgURL
      await db.collection('posts').doc(tweetResponse.id_str).set(postToDB)

      this.$refs.modulePost.postValue = ''
      this.setTweetToRetweet(null)

      alert('ツイートしたよ。ミンナになってくれてありがとう！')

      this.showNowLoading = false

      this.$router.push(`/avatar/${this.$route.params.id}`)
    },
    setImgURL (url) {
      this.imgURL = url
    },
    imageToBase64(img, mime_type) {
      // New Canvas
      var canvas = document.createElement('canvas')
      canvas.width  = img.width
      canvas.height = img.height
      // Draw Image
      var ctx = canvas.getContext('2d')
      // ctx.drawImage(img, 0, 0)
      ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, img.width, img.height)
      // To Base64
      return canvas.toDataURL(mime_type)
    }
  }
}
</script>
